var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHttpHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.438 1.375v14.25h2.078a.297.297 0 01.297.297v.594a.297.297 0 01-.297.297h-5.344a.297.297 0 01-.297-.297v-.594a.297.297 0 01.297-.297h2.078V9.094h-9.5v6.531h2.078a.297.297 0 01.297.297v.594a.297.297 0 01-.297.297H.484a.297.297 0 01-.296-.297v-.594a.297.297 0 01.296-.297h2.079V1.375H.483a.297.297 0 01-.296-.297V.484A.297.297 0 01.483.188h5.344a.297.297 0 01.297.296v.594a.297.297 0 01-.297.297H3.75v6.531h9.5V1.375h-2.078a.297.297 0 01-.297-.297V.484a.297.297 0 01.297-.296h5.344a.297.297 0 01.297.296v.594a.297.297 0 01-.297.297h-2.078z",
    fill: "#3555F0"
  })));
}

export default __webpack_public_path__ + "./fonts/http-header.0ee3821d847645bc2c587450cb1257ac.svg";
export { SvgHttpHeader as ReactComponent };